<template>
  <main class="check-role-account">
    <el-dialog title="查看账号" :visible.sync="auth.isShowCheckDialog">
      <p class="small-title">{{ msg }}</p>
      <el-table :data="auth.roleAuthAccount" border style="width: 100%">
        <el-table-column prop="userName" label="用户名"> </el-table-column>
        <el-table-column prop="nickName" width="200px" label="昵称">
        </el-table-column>
        <el-table-column width="100px" label="账号状态">
          <template slot-scope="scope">
            <span
              :class="{ enable: scope.row.enable, disabled: !scope.row.enable }"
              >{{ scope.row.enable ? '启用中' : '禁用中' }}</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </main>
</template>

<script>
export default {
  created() {
    if (this.auth.totalAccount) {
      this.msg = `该角色下共有${this.auth.totalAccount}个账号`
    } else {
      this.msg = '该角色下暂无账号'
    }
  },
  data() {
    return {
      msg: '',
    }
  },
  computed: {
    auth() {
      return this.$store.state.auth
    },
  },
}
</script>

<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.check-role-account
  .enable
    color self-green
  .disabled
    color #E55164
  .small-title
    margin-bottom 15px
    color gray03
</style>
